import { DateTime } from "luxon";
import { FORM_TIME_ZONE } from "./timezoneUtils";

// The form's pickers hold Eastern wall clock in browser-local Date objects, so "now"
// has to be built the same way or a user outside Eastern would compare against the
// wrong hour.
export const nowInFormZone = (): Date => {
    const now = DateTime.now().setZone(FORM_TIME_ZONE);
    return new Date(now.year, now.month - 1, now.day, now.hour, now.minute, now.second, 0);
};

// Status a new outage should start in, read off its window: not started yet is
// Approved, running now is Active, already over is Completed. Only used on create —
// an existing outage's status is whatever the user last saved.
export const deriveOutageStatus = (
    start: Date | null,
    end: Date | null,
    now: Date = nowInFormZone()
): string => {
    if (!start) return "";
    if (now < start) return "Approved";
    if (end && now >= end) return "Completed";
    return "Active";
};
